var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apexchartvue",attrs:{"id":"chart"},on:{"pointerdown":function($event){$event.stopPropagation();}}},[_c('apexchart',{attrs:{"type":"candlestick","width":"1500px","options":_vm.chartOptions,"series":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }